import React, { useState } from 'react';
import styles from './Utils.module.scss'; // Assuming you have a CSS module for styling
import { AiOutlineCheckCircle } from 'react-icons/ai';
import { Badge } from 'react-bootstrap';
function StatusTag({ show = false }) {
  return show ? (
    <div className={styles.connectedFlag}>
      <AiOutlineCheckCircle size={17} className={styles.icon} />
      <span className={styles.connectedFlagText}>Connected</span>
    </div>
  ) : null;
}

export default StatusTag;
